import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from './SfhSecondaryButton';
import { ReactComponent as GreenCheck } from '../../../assets/images/svg/green_check.svg';
import { ReactComponent as AmberAlertTriangle } from '../../../assets/images/svg/amber-alert-triangle.svg';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';

const HeaderWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding-top: 8px;
`;

const SuccessIcon = styled.div`
  > svg {
    width: 56px;
    height: 56px;
  }
`;

const Title = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  color: ${themeColors.colorTextPrimary};
`;

const Subtitle = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
  color: ${themeColors.colorTextSecondary};
`;

const NoticeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${themeColors.colorBackgroundSecondary};
  border-radius: 4px;
  padding: 12px 16px;
  margin-top: 16px;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};

  > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  > span {
    color: ${themeColors.colorTextSecondary};
  }
`;

const OK_COLOR = themeColors.colorSfhActionBlue;

const FooterWrap = styled.div`
  > button {
    width: 100%;
    color: ${OK_COLOR};
    border-color: ${OK_COLOR};
  }
`;

const SellFromHomeOrderCancelledDrawer = ({ isOpen, onClose, subtitle }) => {
  const { t } = useTranslation();

  const footer = (
    <FooterWrap>
      <SfhSecondaryButton
        onClick={onClose}
        data-cy="button-sfh-order-cancelled-ok"
      >
        {t('sellWizard.sfhWizard.orderCancelled.ok')}
      </SfhSecondaryButton>
    </FooterWrap>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <HeaderWrap>
        <SuccessIcon>
          <GreenCheck />
        </SuccessIcon>
        <Title>{t('sellWizard.sfhWizard.orderCancelled.title')}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeaderWrap>

      <NoticeBox>
        <AmberAlertTriangle />
        <span>
          {t('sellWizard.sfhWizard.transactionHistory.marketLossNotice')}
        </span>
      </NoticeBox>
    </BottomDrawer>
  );
};

SellFromHomeOrderCancelledDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
};

export default SellFromHomeOrderCancelledDrawer;
